module.exports = __webpack_public_path__ + "img/null.8e94dde.png";